import type { UseQueryOptions } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import { comboService } from '../services/combo.service';

import type { ComboSummary } from '../types/ComboSummary';
import type { ApiResponse, ErrorResponse } from '../services/api.types';
import type { ComboCoverageViewModel } from '../types/ComboCoverageViewModel';

export const useCombos = (options?: UseQueryOptions<ApiResponse<ComboSummary[]>, ErrorResponse>) =>
  useQuery<ApiResponse<ComboSummary[]>, ErrorResponse>({
    queryKey: ['combos'],
    queryFn: () => comboService.getCombos(),
    ...options,
  });

export const useComboCoveragesById = (
  comboId: number,
  options?: UseQueryOptions<ApiResponse<ComboCoverageViewModel>, ErrorResponse>
) =>
  useQuery<ApiResponse<ComboCoverageViewModel>, ErrorResponse>({
    queryKey: ['comboCoverages', comboId],
    queryFn: () => comboService.getCombosById(comboId),
    enabled: !!comboId,
    ...options,
  });
